// ロコモ比較する.
import * as React from 'react';
import * as PropTypes from 'prop-types';
import TrainingGraphsCompare, { DummyTrainingGraphsCompare } from './common/TrainingGraphsCompare';
import MonthlyHistoryCompare from './common/MonthlyHistoryCompare';
import DailyHistoryCompare from './common/DailyHistoryCompare';
import * as MoffAPI from '../constants/MoffAPI';
import { MDate, validateLongterm } from '../utils/dateUtil';
import { Global } from '../utils/global';
import * as TrainingConst from '../constants/Training';
import { TrainingMenu } from '../constants/Training';

// 印刷ボタンのCSS.
const printCss: React.CSSProperties = {
  marginLeft: '92.3%',
  marginTop: '-1.0%'
};

interface LocomoCompareState {
  // エラーメッセージ.
  termErrorMessage: string;
  startYearMonth: string;
  endYearMonth: string;
}

interface LocomoCompareProps extends React.Props<{}> {
  moffAPIActions: any;

  mDate: MDate;

  // 前ページのユーザーID.
  userId: string;

  Loaded: boolean;

  startData: any;
  endData: any;

  trainingMenus: TrainingMenu[];
}

// 利用者一覧の表のフィールド表示用コンポーネント
export default class LocomoCompare extends React.Component<LocomoCompareProps, LocomoCompareState> {
  mDate: MDate;
  termErrorMessage: string;

  startYearMonth: any;
  endYearMonth: any;
  startMDate: MDate;
  endMDate: MDate;

  static get childContextTypes() {
    return {
      callbackParent: PropTypes.func,
    };
  }

  // 各子のコンポーネントから呼ばれるcontext管理.
  getChildContext() {
    const callback: Function = (isStartTerm: boolean, yearmonth: string) => {
      let startDate: string = this.startMDate.yearmonth;
      let endDate: string = this.endMDate.yearmonth;

      if (isStartTerm) {
        startDate = yearmonth;
      } else {
        endDate = yearmonth;
      }

      // URLのパラメータ.
      const arr: string[] = [startDate, endDate];
      this.props.moffAPIActions.getCompareData(MoffAPI.LOCOMO_TYPE, this.props.userId, arr);
    };

    return {
      callbackParent: callback,
    };
  }

  constructor(props: LocomoCompareProps) {
    super(props);

    // 開始YYYY-MM
    let startYearMonth: string = '';
    // 終わりYYYY-MM
    let endYearMonth: string = '';

    if (Global.locomoStartYearMonth && Global.locomoEndYearMonth) {
      startYearMonth = Global.locomoStartYearMonth;
      endYearMonth = Global.locomoEndYearMonth;

      this.startMDate = new MDate(new Date(startYearMonth));
      this.endMDate = new MDate(new Date(endYearMonth));
    } else {
      // 開始.
      const preDate: MDate = new MDate();
      preDate.setPreMonth(1); // 1ヶ月前にする.
      this.startMDate = preDate;

      // 終わり.
      const nowDate: MDate = new MDate();
      startYearMonth = preDate.getYearMonth();
      endYearMonth = nowDate.getYearMonth();
      this.endMDate = nowDate;
    }

    this.state = {
      // 日付がエラーか.
      termErrorMessage : '',
      // 開始と終わり.
      startYearMonth: startYearMonth,
      endYearMonth: endYearMonth,
    };

    // 最初に一回通信.
    this.runAPI(this.state.startYearMonth, this.state.endYearMonth);
  }

  static get contextTypes() {
    // 親のLocomoコンポーネントと橋渡しするcontext.
    return {
      changeState: PropTypes.func
    };
  }

  shouldComponentUpdate(nextProps: LocomoCompareProps, nextState: LocomoCompareState): boolean {
    return true;
  }

  componentWillMount() {
    this.mDate = this.props.mDate;
  }

  // 「終了」をクリックしたときの処理
  handleFinishClicked = () => {
    // 長期変化を見なくする.
    this.context.changeState(TrainingConst.DETAIL_STATE);
  }

  changeStart = () => {
    this.judge();
  }

  changeEnd = () => {
    this.judge();
  }

  judge = () => {
    let isValid: boolean = false;
    const startYearMonth: string = this.startYearMonth.value.toString();
    const endYearMonth: string = this.endYearMonth.value.toString();

    // ここにも反映しないとinputの中身が変わらない.
    this.setState(
      {
        startYearMonth: startYearMonth,
        endYearMonth: endYearMonth,
      }
    );

    // フォーマット: 2017-01
    isValid = validateLongterm(startYearMonth, endYearMonth);

    if (isValid) {
      this.setState(
        {termErrorMessage: ''}
      );

      // ページ前後しても記録させるため.
      Global.locomoStartYearMonth = startYearMonth;
      Global.locomoEndYearMonth = endYearMonth;

      // 通信.
      this.runAPI(startYearMonth, endYearMonth);
    } else {
      this.setState(
        {termErrorMessage: '期間は1年以内で、正しく指定してください。'}
      );
    }
  }

  // 範囲内でAPIを叩く.
  runAPI(startDate: string, endDate: string) {
    // URLのパラメータ.
    const arr: string[] = [startDate, endDate];

    // TypeはLocomo.
    this.props.moffAPIActions.getCompareData(MoffAPI.LOCOMO_TYPE, this.props.userId, arr);
  }

  render() {
    return (
      <div>
        <section id="sec01">
          { Global.isApp ?
            (null)
          :
            <a
              href="#"
              onClick={event => {window.print(); return false; }}
              className="btn btn-default"
              role="button"
              style={printCss}
            >
              印刷
            </a>
          }
        </section>
        <div>
          {/* トレーニング履歴 （月次）. */}
          <MonthlyHistoryCompare
            userId={this.props.userId}
            trainingMenus={this.props.trainingMenus}
            startData={this.props.startData}
            endData={this.props.endData}
            startMDate={this.startMDate}
            newMDate={this.endMDate}
            type={TrainingConst.TYPE.Locomo}
          />
          {/* トレーニング履歴（日次）. */}
          <DailyHistoryCompare
            userId={this.props.userId}
            trainingMenus={this.props.trainingMenus}
            startData={this.props.startData}
            endData={this.props.endData}
            startMDate={this.startMDate}
            endMDate={this.endMDate}
            type={TrainingConst.TYPE.Locomo}
          />
          {(this.props.Loaded && this.props.startData && this.props.endData) ? 
            <section id="sec04">
              <h2 className="ttlStyle01">1ヶ月の変化</h2>
              <div className="inner">
                <TrainingGraphsCompare
                  userId={this.props.userId}
                  className="startReport"
                  history={this.props.startData}
                  mDate={this.startMDate}
                  isStartTerm={true}
                  type={TrainingConst.TYPE.Locomo}
                />
                <TrainingGraphsCompare
                  userId={this.props.userId}
                  className="endReport"
                  history={this.props.endData}
                  mDate={this.endMDate}
                  isStartTerm={false}
                  type={TrainingConst.TYPE.Locomo}
                />
              </div>
            </section>
          :
            <section id="sec04">
              <h2 className="ttlStyle01">1ヶ月の変化</h2>
              <div className="inner">
                <DummyTrainingGraphsCompare
                  className="startReport"
                  mDate={this.startMDate}
                  isStartTerm={true}
                  type={TrainingConst.TYPE.Locomo}
                />
                <DummyTrainingGraphsCompare
                  className="endReport"
                  mDate={this.endMDate}
                  isStartTerm={false}
                  type={TrainingConst.TYPE.Locomo}
                />
              </div>
            </section>
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LocomoCompare.tsx